import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Graph from "../Staking/section/Graph";
import "../../Assets/Css/dashboard.css";
import { useAccount, useWalletClient } from "wagmi";
import stakeContract from "../../../Contract/stakContract.json";
import {
  callReadContract,
  addTokenToWallet,
  callWriteContract,
  formatBalance,
} from "../../../Contract/utils";
import { useDisconnect } from "wagmi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Reward from "../Staking/Modal/Reward";
import { Link } from "react-router-dom";
import ZeussToken from "../../../Contract/zeussToken.json"
const DashboardStaking = () => {
  const user = useAccount();
  const [stakeHistory, setStakeHistory] = useState();
  const [rewardModal, setRewardModal] = useState(false);
  const [claimAmount, setClaimAmount] = useState("");
  const [claimDuration, setClaimDuration] = useState("");
  const [id, setId] = useState();
  const [emer, setEmer] = useState(false);
  const [txn, setTxn] = useState("");
  const { data: walletClient } = useWalletClient();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Total number of pages
  const totalPages = Math.ceil((stakeHistory?.length || 0) / itemsPerPage);

  // Get transactions for the current page
  const currentStakes = stakeHistory?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const addToken = async () => await addTokenToWallet(walletClient);

  const getUserStakeHistory = async () => {
    try {
      const stakeHis = await callReadContract(
        stakeContract.address,
        stakeContract.abi,
        "getStakingHistory",
        [user.address]
      );
      setStakeHistory([...stakeHis].reverse());
    } catch (e) {
      console.log("error in get value", e);
    }
  };

  useEffect(() => {
    if (user.address) {
      getUserStakeHistory();
    }
  }, [user, txn]);

  const { disconnect } = useDisconnect();
  const navigate = useNavigate();

  const handleDisconnect = () => {
    disconnect();
    navigate("/");
  };
  return (
    <>
      <div className="topbar">
        <h4>
          $ZEUSS Contract Address{" "}
          <Link
            target="_blank"
            to={`https://etherscan.io/token/${ZeussToken.address}`}
          >
            {ZeussToken.address}
          </Link>
        </h4>
      </div>
      <div className="dashboardapp">
        <Sidebar />
        <div className="main-content">
          <header className="d-flex justify-content-end align-items-center inner-content gap-2 gap-lg-5">
            <div className="d-flex align-items-center justify-content-end gap-2 gap-sm-4">
              <svg
                onClick={() => handleDisconnect()}
                style={{ cursor: "pointer" }}
                width="34"
                height="33"
                viewBox="0 0 34 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 16.5C6 16.8797 6.30783 17.1875 6.6875 17.1875H18.7779L15.1389 20.8264C15.01 20.9553 14.9376 21.1301 14.9376 21.3124C14.9375 21.6921 15.2453 21.9999 15.625 22C15.8074 22.0002 15.9823 21.9277 16.111 21.7986L20.9235 16.9861C20.9234 16.9862 20.9236 16.986 20.9235 16.9861C21.1918 16.7176 21.192 16.2823 20.9235 16.014L16.111 11.2015C15.8446 10.9442 15.4222 10.9442 15.1558 11.2015C14.8827 11.4653 14.8751 11.9005 15.1389 12.1736L18.7779 15.8125H6.6875C6.30783 15.8125 6 16.1203 6 16.5ZM24.5625 2.75H9.4375C7.53974 2.75176 6.00176 4.28974 6 6.1875V11.6875C6 12.0672 6.30783 12.375 6.6875 12.375C7.06717 12.375 7.375 12.0672 7.375 11.6875V6.1875C7.37626 5.04891 8.29891 4.12626 9.4375 4.125H24.5625C25.7011 4.12626 26.6237 5.04891 26.625 6.1875V26.8125C26.6237 27.9511 25.7011 28.8737 24.5625 28.875H9.4375C8.29891 28.8737 7.37626 27.9511 7.375 26.8125V21.3125C7.375 20.9328 7.06717 20.625 6.6875 20.625C6.30783 20.625 6 20.9328 6 21.3125V26.8125C6.00176 28.7103 7.53974 30.2482 9.4375 30.25H24.5625C26.4603 30.2482 27.9982 28.7103 28 26.8125V6.1875C27.9982 4.28974 26.4603 2.75176 24.5625 2.75Z"
                  fill="#0A61CB"
                />
              </svg>
            </div>
          </header>
          <div className="mt-5">
            <Graph setTxn={setTxn} />
            <Reward
              show={rewardModal}
              amount={claimAmount}
              duration={claimDuration}
              emer={emer}
              modal={setRewardModal}
              id={id}
              setTxn={setTxn}
            />
          </div>
          <div className="row pt-3">
            <div className="col-xl-7">
              <div className="inner-content-dashboard mt-4">
                <div className="row">
                  <div className="col-lg-12">
                    <div>
                      <h2 className="pb-3">Staking History</h2>
                      <p className="d-flex align-items-center gap-1">
                        {" "}
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.1543 2.27328C4.82035 2.27328 2.10791 4.98573 2.10791 8.31967C2.10791 11.6536 4.82035 14.3661 8.1543 14.3661C11.4882 14.3661 14.2007 11.6536 14.2007 8.31967C14.2007 4.98573 11.4882 2.27328 8.1543 2.27328ZM11.301 6.29326L7.39414 10.9443C7.35128 10.9954 7.29796 11.0366 7.23777 11.0653C7.17759 11.0939 7.11195 11.1093 7.04531 11.1103H7.03746C6.97227 11.1103 6.90781 11.0966 6.84827 11.07C6.78872 11.0435 6.73542 11.0047 6.69183 10.9562L5.01744 9.09582C4.97492 9.05072 4.94184 8.99757 4.92015 8.9395C4.89846 8.88143 4.8886 8.81962 4.89114 8.75768C4.89368 8.69575 4.90858 8.63494 4.93496 8.57885C4.96133 8.52275 4.99865 8.4725 5.04473 8.43103C5.09081 8.38956 5.14471 8.35773 5.20326 8.33739C5.26182 8.31706 5.32385 8.30863 5.38571 8.31261C5.44757 8.31659 5.50801 8.33289 5.56348 8.36056C5.61895 8.38823 5.66832 8.42671 5.70871 8.47374L7.02525 9.9365L10.5888 5.69502C10.6688 5.6026 10.7819 5.54535 10.9037 5.53565C11.0255 5.52594 11.1462 5.56456 11.2398 5.64315C11.3333 5.72174 11.3922 5.83399 11.4037 5.95565C11.4151 6.0773 11.3783 6.19857 11.301 6.29326Z"
                            fill="#01B574"
                          />
                        </svg>{" "}
                        done{" "}
                      </p>
                    </div>
                    <div className="table-responsive pt-3">
                      <table>
                        <thead>
                          <tr>
                            <th>Amount</th>
                            <th>Time</th>
                            <th>Reward</th>
                            <th>APY</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentStakes && currentStakes.length > 0 ? (
                            currentStakes.map((td, index) => (
                              <tr
                                key={index}
                                style={{
                                  borderBottom:
                                    "1px solid rgba(255, 255, 255, 0.40)",
                                }}
                              >
                                <td>{formatBalance(td.amount, 18, 2)}</td>
                                <td>
                                  {td.stakingPeriod === 15724800
                                    ? "6 Months"
                                    : "12 Months"}
                                </td>
                                <td>
                                  {formatBalance(td.potentialReward, 18, 18)}
                                </td>
                                <td>{td.currentAPY}%</td>
                                <td>
                                  {td.isWithdrawn ? (
                                    "Withdrawn"
                                  ) : td.withdrawAvailable ? (
                                    <button
                                      className="Withdrawn"
                                      onClick={() => {
                                        setId(td.index);
                                        setRewardModal(true);
                                        setClaimAmount(
                                          td.amount + td.potentialReward
                                        );
                                        setClaimDuration(td.stakingPeriod);
                                        setEmer(false);
                                      }}
                                    >
                                      Withdraw
                                    </button>
                                  ) : (
                                    <button
                                      className="EarlyWithdraw"
                                      onClick={() => {
                                        setId(td.index);
                                        setRewardModal(true);
                                        setClaimAmount(
                                          td.amount + td.potentialReward
                                        );
                                        setClaimDuration(td.stakingPeriod);
                                        setEmer(true);
                                      }}
                                    >
                                      Early Withdraw
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                style={{ textAlign: "center", padding: "10px" }}
                              >
                                No History
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination Controls */}
                    {totalPages > 1 && (
                      <div
                        className="pagination"
                        style={{ textAlign: "center", marginTop: "15px" }}
                      >
                        <button
                          onClick={() => setCurrentPage(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Prev
                        </button>
                        <span style={{ margin: "0 10px" }}>
                          Page {currentPage} of {totalPages}
                        </span>
                        <button
                          onClick={() => setCurrentPage(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 pt-3 pt-xl-0">
              <div
                className="inner-content-dashboard mt-4"
                style={{ cursor: "pointer" }}
                onClick={addToken}
              >
                <div className="meta-mask d-flex align-items-center gap-4">
                  <img src="/images/Metamask.png" alt="" />
                  <h2>
                    <h2>Add Zeuss To Network</h2>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardStaking;
